import React, { useEffect, useRef, useState } from "react";
import _ from "lodash";
import { MatchScoreWidget } from "../../../../frontend/templates/_partials/MatchScoreWidget/Index";
import borderFrame from '../../../../frontend/templates/fcb/ResultsNew/images/border_BG_empty.png'
import getContentById from "../../../utils/getContentById";
import { formatMinute, parseMinute, sortByTimeFirst } from "../../../../frontend/templates/fcb/ResultsNew/Index";
import { PresetColors } from "./LeftSidebar/EditTab";
import { useTranslation } from "react-i18next";
import { getOneLetterResult } from "../../../../frontend/templates/fcb/MatchdaySlider/Index";
import TeamLogo from "../../../../frontend/templates/_partials/TeamLogo";

const FCBSlider3Content = ({ data, ...props }) => {
    const templateName = data?.template_name ?? "";
    const id = `${templateName}_${data?.uuid}`;

    const { options, fields, dynamic, editData } = data.data;
    const {
        last10Matches,
        timezones,
    } = data?.data?.dynamic;

    const homeTeam = data?.event?.home;
    const awayTeam = data?.event?.away;
    let statsLeftTeam = homeTeam;
    let statsRightTeam = awayTeam;
    if (statsRightTeam.shortcut == 'FCB') {
        statsLeftTeam = awayTeam;
        statsRightTeam = homeTeam;
    }

    const competitionId = data?.event?.competitionId;


    return (
        <div id={id} className="T_fcb_matchday_slider_3" style={{ zIndex: 101 }}>
            <div className={"wc-content wc-content-v2"}
                style={{
                    transform: 'scale(0.41)',
                    left: -355,
                    color: 'white',
                    zIndex: 1
                }}

            >
                <div className="match-results-container">
                    <div className="match-results-left-container">
                        {
                            last10Matches?.slice(0, 5).map((item) => {
                                const { matchInfo, liveData: { matchDetails } } = item;
                                const _homeTeam = matchInfo?.contestant?.[0];
                                const _awayTeam = matchInfo?.contestant?.[1];
                                const score = matchDetails?.scores?.total;
                                let homeScore = score?.home ?? 0;
                                let awayScore = score?.away ?? 0;
                                const date = matchInfo?.date?.replace('Z', '');
                                return (
                                    <div className="result-item">
                                        <div className="home-team-logo-container">
                                            <TeamLogo team={_homeTeam} competitionId={competitionId} />
                                        </div>
                                        <div className="item-score-container">
                                            <div className="item-score-date">
                                                {date}
                                            </div>
                                            <div className="item-score-value">
                                                {homeScore} - {awayScore}
                                            </div>
                                        </div>
                                        <div className="away-team-logo-container">
                                            <TeamLogo team={_awayTeam} competitionId={competitionId} />
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>

                    <div className="match-results-right-container">
                        {
                            last10Matches?.slice(5).map((item) => {
                                if (!item) return <></>;
                                const { matchInfo, liveData: { matchDetails } } = item;
                                const _homeTeam = matchInfo?.contestant?.[0];
                                const _awayTeam = matchInfo?.contestant?.[1];
                                const score = matchDetails?.scores?.total;
                                let homeScore = score?.home ?? 0;
                                let awayScore = score?.away ?? 0;
                                const date = matchInfo?.date?.replace('Z', '');
                                return (
                                    <div className="result-item">
                                        <div className="home-team-logo-container">
                                            <TeamLogo team={_homeTeam} competitionId={competitionId} />
                                        </div>
                                        <div className="item-score-container">
                                            <div className="item-score-date">
                                                {date}
                                            </div>
                                            <div className="item-score-value">
                                                {homeScore} - {awayScore}
                                            </div>
                                        </div>
                                        <div className="away-team-logo-container">
                                            <TeamLogo team={_awayTeam} competitionId={competitionId} />
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
            <div className="gradient-left"></div>
            <div className="gradient-right"></div>
        </div>

    );
};

export default FCBSlider3Content;
